module.exports = __webpack_public_path__ + "static/fonts/Quicksand-Regular.c984b33.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Regular.eot
// module id = X2aM
// module chunks = 1